const BlogCatalog = () => import("@/views/modules/sport/BlogCatalog.vue");
const SingleBlog = () => import("@/views/modules/sport/SingleBlog.vue");
const VideoCatalog = () => import("@/views/modules/sport/VideoCatalog.vue");
const SingleVideo = () => import("@/views/modules/sport/SingleVideo.vue");
const FavoriteVideo = () => import("@/views/modules/sport/FavoriteVideo.vue");
const AllPlaylists = () => import("@/views/modules/sport/AllPlaylists.vue");
const SinglePlaylist = () => import("@/views/modules/sport/SinglePlaylist.vue");
const Preferences = () => import("@/views/modules/sport/Preferences.vue");
const ChartCatalog = () => import("@/views/modules/sport/ChartCatalog.vue");

export default [
  {
    path: "/blog/catalog",
    name: "blog-catalog",
    component: BlogCatalog,
    meta: { allowedSubdomains: ["portal"], hideForPortalTypeBooks: true },
  },
  {
    path: "/blog/:id",
    name: "single-blog",
    component: SingleBlog,
    meta: {
      requiresAuth: true,
      allowedSubdomains: ["portal"],
      hideForPortalTypeBooks: true,
    },
  },
  {
    path: "/video/catalog",
    name: "video-catalog",
    component: VideoCatalog,
    meta: { allowedSubdomains: ["portal"], hideForPortalTypeBooks: true },
  },
  {
    path: "/video/:id",
    name: "single-video",
    component: SingleVideo,
    meta: {
      requiresAuth: true,
      allowedSubdomains: ["portal"],
      hideForPortalTypeBooks: true,
    },
  },
  {
    path: "/video/favorite",
    name: "favorite-video",
    component: FavoriteVideo,
    meta: {
      requiresAuth: true,
      allowedSubdomains: ["portal"],
      hideForPortalTypeBooks: true,
    },
  },
  {
    path: "/playlists",
    name: "playlists",
    component: AllPlaylists,
    meta: {
      requiresAuth: true,
      allowedSubdomains: ["portal"],
      hideForPortalTypeBooks: true,
    },
  },
  {
    path: "/playlists/:id",
    name: "single-playlist",
    component: SinglePlaylist,
    meta: {
      requiresAuth: true,
      allowedSubdomains: ["portal"],
      hideForPortalTypeBooks: true,
    },
  },
  {
    path: "/preferences",
    name: "preferences",
    component: Preferences,
    meta: {
      requiresAuth: true,
      allowedSubdomains: ["portal"],
      hideForPortalTypeBooks: true,
    },
  },
  {
    path: "/chart",
    name: "chart",
    component: ChartCatalog,
    meta: {
      allowedSubdomains: ["portal"],
      hideForPortalTypeBooks: true,
    },
  },
];
